import AppHeader from '@/components/layout/AppHeader'

export default function PrivacyPolicy() {
  return (
    <div className="flex flex-col h-full bg-white">
      <AppHeader title="Privacy Policy" showBack />
      <div className="screen no-scrollbar px-4 sm:px-6 lg:px-8 py-5">
        <div className="mx-auto w-full max-w-4xl card space-y-3">
          <p className="text-sm text-slate-700 leading-relaxed">
            GoodGuardian is committed to safeguarding your information. We collect account and usage data
            only to provide app functionality, security, and support.
          </p>
          <p className="text-sm text-slate-700 leading-relaxed">
            Data may include profile details, logs, uploaded files, and generated content. Sensitive information
            is stored with reasonable technical protections and access controls.
          </p>
          <p className="text-sm text-slate-700 leading-relaxed">
            GoodGuardian provides legal education, not legal advice. You are responsible for reviewing and validating
            outputs with a licensed attorney before legal use.
          </p>
          <p className="text-xs text-slate-500">Last updated: March 24, 2026</p>
        </div>
      </div>
    </div>
  )
}
